import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import selectors from '../hooks/selectors';
import fetch from '../hooks/fetch';

const listItems = (workflows) => workflows.map((workflow) => ({
  key: `dataset_workflows_${workflow.code}`,
  text: workflow.workflow.name,
  value: workflow.code,
  icon: workflow.engine === 'camunda' ? 'sitemap' : 'random',
}));

const WorkflowsDropdown = ({
  category,
  className,
  direction,
  disabled,
  onChange,
  workflowKey,
}) => {
  const intl = useIntl();
  const { readStatus, workflows } = selectors.useWorkflowsDropdown({ category });
  fetch.useFetchWorkflows(category, readStatus);
  return (
    <Dropdown
      className={clsx('aridhia-workflows-dropdown', 'max-content', className)}
      id="dataset_workflow"
      options={listItems(workflows)}
      disabled={disabled}
      direction={direction}
      value={workflowKey}
      fluid
      selection
      clearable
      loading={readStatus === states.PENDING}
      placeholder={intl.formatMessage({ id: 'dataset.workflow.placeholder' })}
      onChange={(e, { value }) => onChange(findMatch(workflows, value))}
    />
  );
};

export default WorkflowsDropdown;
